export class AIConstants {
    static readonly TINYMCE_AI_INSTRUCTIONS_TEXT = 'AI Assistant: Highlight text to replace it, or use with no selection to replace entire content.';

    static readonly TINYMCE_AI_SHORTCUTS = [
        { title: 'Improve writing', prompt: 'Please improve the writing style of this text' },
        { title: 'Fix grammar', prompt: 'Please fix any grammar and spelling issues' },
        { title: 'Make more formal', prompt: 'Please rewrite this text in a more formal tone' },
        { title: 'Make more casual', prompt: 'Please rewrite this text in a more casual tone' },
        { title: 'Summarize', prompt: 'Please provide a concise summary of this content' },
    ];

    static readonly TINYMCE_AI_DEFAULT_PROMPTS = {
        EMAIL_ENHANCEMENT: 'Please enhance this email to be more professional and clear while maintaining the original message and tone.',
        CONTENT_IMPROVEMENT: 'Please improve this content for better readability and engagement.',
        GRAMMAR_FIX: 'Please fix any grammar, spelling, and punctuation errors in this text.',
        TONE_FORMAL: 'Please rewrite this text using a more formal and professional tone.',
        TONE_CASUAL: 'Please rewrite this text using a more casual and friendly tone.',
        SUMMARIZE: 'Please provide a clear and concise summary of this content.',
    };
}
